import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=04c12cb0&scoped=true&"
import script from "./EditItem.vue?vue&type=script&lang=js&"
export * from "./EditItem.vue?vue&type=script&lang=js&"
import style0 from "./EditItem.vue?vue&type=style&index=0&id=04c12cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c12cb0",
  null
  
)

export default component.exports